import { render, staticRenderFns } from "./notifications-outbox-tabs.vue?vue&type=template&id=31e5a952&scoped=true"
import script from "./notifications-outbox-tabs.vue?vue&type=script&lang=js"
export * from "./notifications-outbox-tabs.vue?vue&type=script&lang=js"
import style0 from "./notifications-outbox-tabs.vue?vue&type=style&index=0&id=31e5a952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e5a952",
  null
  
)

export default component.exports